var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgIngress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.363 11V2.274H6.63v.938H2.42V6.16h3.938v.937H2.42v2.966H6.7v.938H1.363z",
    fill: "#500d76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3.33h-.777v6.613H11V11H8.392V9.943h.774V3.33h-.774V2.273H11V3.33z",
    fill: "#500d76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgIngress);
export default __webpack_public_path__ + "static/media/eg-ingress.117afe04ceb49fb81fa084f219970347.svg";
export { ForwardRef as ReactComponent };